import MotionWrapper from '../../../layouts/MotionWrapper';
import styles from './style.module.scss';
import LegalContainer from '../../../containers/Legal';

export default function Legal() {
    return (
        <MotionWrapper className={styles.container}>
            <LegalContainer />
        </MotionWrapper>
    );
};
